import { render, staticRenderFns } from "./SocietyView.vue?vue&type=template&id=39a81370&scoped=true&"
import script from "./SocietyView.vue?vue&type=script&lang=js&"
export * from "./SocietyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a81370",
  null
  
)

export default component.exports